import React, { FunctionComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import { connect } from 'react-redux';
import { BaseModal, toggleDieticianModal } from '../../ui';
import DieticianNutritionSource from './DieticianNutritionSource';

interface IProps {
  isDieticianModalVisible: boolean;
  toggleDieticianModal: (visible: boolean) => void;
  isLoading: boolean;
}

const SettingsDietitianComponent: FunctionComponent<IProps> = ({
                                                                 isDieticianModalVisible,
                                                                 toggleDieticianModal: toggleModal,
                                                                 isLoading,
                                                               }) => {
  return (
    <BaseModal
      closeModal={() => toggleModal(false)}
      title={''}
      containerStyle={{ height: '100vh' }}
      isModalVisible={isDieticianModalVisible}>
      <View style={{ flex: 1 }}>
        <DieticianNutritionSource
          isLoading={isLoading}
          closeModal={this.closeDieticianModal}
        />
      </View>
    </BaseModal>
  );
};

const mapStateToProps = (state) => {
  return {
    isDieticianModalVisible: state.ui.dieticianModalVisible,
    isLoading: state.nutrition.isLoading,
  };
};

export const NutritionDietitianModal = connect(mapStateToProps, { toggleDieticianModal })(SettingsDietitianComponent);
